import { Send } from 'lucide-react';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, IconButton } from '../ui';
import FormTransfert from './FormTransfert';
import FormDrawer from '../ui/FormDrawer';


const extensiosValide = 'image/*, video/*, .pdf, .avi';

export default function TranfertOpe(props: { reccord?: any, disabled: boolean, fullWidth?: boolean }) {
    const [open, setOpen] = React.useState(false);
    const [isOk, setIsOk] = useState<boolean>(false)
    const { register, handleSubmit } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [loading, setLoading] = useState<boolean>(false)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {props.fullWidth ? (
                <Button
                    disabled={props.disabled}
                    onClick={handleClickOpen}
                    className="w-full font-semibold normal-case"
                    startIcon={<Send size={16} />}
                >
                    Transférer
                </Button>
            ) : (
                <IconButton disabled={props.disabled} onClick={handleClickOpen} color='primary' size={32}><Send size={16} /></IconButton>
            )}
            <FormDrawer
                open={open}
                onClose={handleClose}
                title={`Transfert du ticket ${props.reccord?.CodeT || ''}`}
                hint="Sélectionnez la caisse ou le guichet de destination pour transférer ce ticket."
            >
                <FormTransfert handleFunction={handleClose} reccord={props.reccord} />
            </FormDrawer>
        </div>
    );
}
